 // src/components/authentication/SignIn.js

 import React, { useState, useEffect } from "react";
 import { Link } from "react-router-dom";
 import { signInWithEmailAndPassword } from "firebase/auth";

 import { useNavigate } from "react-router-dom";
 import { getAuth, signInWithPopup, GoogleAuthProvider, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
 
 
 import "./SignIn.css";
 import { Icon } from '@iconify/react';
 
 
 function SignIn() {
   const [email, setEmail] = useState("");
   const [password, setPassword] = useState("");
   const [user, setUser] = useState(null);

   const auth = getAuth();
   const [error, setError] = useState(null); // Initialize error state
   const navigate = useNavigate(); // Initialize useNavigate

   const [phoneNumber, setPhoneNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [message, setMessage] = useState("");

   // Initialize Recaptcha
   const setupRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
        size: "invisible",
        callback: (response) => {
          console.log("Recaptcha Verified!", response);
        },
        "expired-callback": () => {
          console.log("Recaptcha expired. Please refresh.");
        },
      });
    }
  };
  

  // Handle sending OTP
  const formatPhoneNumber = (number) => {
    // Assume South Africa (+27) by default
    if (number.startsWith("0")) {
      return "+27" + number.substring(1); // Convert 0711234567 -> +27711234567
    }
    return number; // If already in international format, return as is
  };
  
  const sendOTP = async () => {
    if (!phoneNumber) {
      setMessage("Enter a valid phone number");
      return;
    }
  
    const formattedNumber = formatPhoneNumber(phoneNumber); // Convert 071 -> +27 format
    setupRecaptcha();
  
    const appVerifier = window.recaptchaVerifier;
    if (!appVerifier) {
      setMessage("Recaptcha not initialized, try again.");
      return;
    }
  
    try {
      const confirmation = await signInWithPhoneNumber(auth, formattedNumber, appVerifier);
      setConfirmationResult(confirmation);
      setMessage(`OTP sent to ${formattedNumber}`);
    } catch (error) {
      console.error("Error sending OTP:", error);
      setMessage("Error sending OTP: " + error.message);
    }
  };
  

  // Handle OTP verification
  const verifyOTP = async () => {
    if (!verificationCode) {
      setMessage("Enter the OTP");
      return;
    }
    try {
      await confirmationResult.confirm(verificationCode);
      setMessage("Phone verified successfully!");
    } catch (error) {
      setMessage("Invalid OTP, please try again.");
    }
  };
 
 
   const handleSubmit = async (e) => {
     e.preventDefault();
     try {
       // Sign in with email and password
       await signInWithEmailAndPassword(auth, email, password);
       // Redirect to Profile.js after successful sign-in
       navigate("/dashboard");
       // You can use react-router for this navigation
       // Example: history.push("/profile"); 
     } catch (error) {
      console.error("Firebase Error:", error);

       
      // Set a custom error message based on the Firebase error code
      let errorMessage = "An error occurred during sign-in.";
      if (error.code === "auth/user-not-found") {
        errorMessage = "User not found. Please check your email.";
      } else if (error.code === "auth/wrong-password") {
        errorMessage = "Incorrect password. Please try again.";
      }


      setError(errorMessage);
    }
   };

   const handleEmailInput = () => {
    // Clear the error message when the user interacts with the email input
    setError(null);
  };

  const handlePasswordInput = () => {
    // Clear the error message when the user interacts with the password input
    setError(null);
  };

   const handleGoogleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      navigate("/dashboard");
    } catch (error) {
      console.error("Error signing in with Google:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });
  
    // Make sure to unsubscribe when the component unmounts
    return () => unsubscribe();
  }, []);
 
  const homeButtonStyle = {

    position: 'fixed',
  
    left: '10px',
    top: '20px',
    
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'right', 
   
      margin: '0 5px', // Margin between buttons
      padding: '8px', // Padding inside buttons
      cursor: 'pointer', // Cursor style
    };
  
 
   return (
     <main className="main">

<link
  href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;800&display=swap"
  rel="stylesheet"
/>


<div>


</div>
<div className="sign-in-parent-container">
<div className="header-account-settings">

  
         <section className="wrapper">
           <div className="heading">
           <p className="text text-normal">
               <span><Link to="/marketplace" className="text text-links">Retun to Job Posts</Link></span>
              </p>
             <h1 className="text text-large">Sign In to manage job posts</h1>
           </div>
           <form name="signin" className="form" onSubmit={handleSubmit}>
             <div className="input-control">
               <label htmlFor="email" className="input-label" hidden>
                 Email Address
               </label>
               <input
                 type="email"
                 name="email"
                 id="email"
                 className="input-field"
                 placeholder="Email Address"
                 value={email}
                 onChange={(e) => setEmail(e.target.value)}
                 onFocus={handleEmailInput} // Clear error on focus required
               />
             </div>
             <div className="input-control">
               <label htmlFor="password" className="input-label" hidden>
                 Password
               </label>
               <input
                 type="password"
                 name="password"
                 id="password"
                 className="input-field"
                 placeholder="Password"
                 value={password}
                 onChange={(e) => setPassword(e.target.value)}
                 onFocus={handlePasswordInput} // Clear error on focus required
               />
             </div>
             <div className="input-control">
               <Link to="/reset-password" className="text text-links">
                 Forgot Password
               </Link>
               <input
                 type="submit"
                 name="submit"
                 className="input-submit"
                 value="Sign In"
                 // Enable the submit button only when email and password are not empty
                 disabled={!email || !password}
               />
             </div>
           </form>
           {/* Display the error message if it exists */}
      {error && <div className="error-message">{error}</div>}
           <div className="striped">
             <span className="striped-line"></span>
         {/*}    <span className="striped-text">Or</span>*/}
             <span className="striped-line"></span>
           </div>
           <div className="method">
            <div className="method-control">
                          {/* Use a function to open Google sign-in popup */}
                          <button onClick={handleGoogleSignIn} className="method-action">
                          <Icon icon="flat-color-icons:google" width="24" height="24" className="icon-before"/>
                          <span className="button-text">Sign in with Google</span>
                          </button>
                        </div>
                        <div className="method-control">
                          <p className="text text-normal">
                            Already a User? <span><Link to="/sign-in" className="text text-links">Sign In to your account</Link></span>
                          </p>
                        </div>
      {/*     <div>
      <h2>Phone Authentication</h2>
      <input
        type="text"
        placeholder="Enter phone number (e.g. 0718951188)"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
      />
      <button onClick={sendOTP}>Send OTP</button>

      {confirmationResult && (
        <>
          <input
            type="text"
            placeholder="Enter OTP"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
          />
          <button onClick={verifyOTP}>Verify OTP</button>
        </>
      )}

      <div id="recaptcha-container"></div>
      <p>{message}</p>
    </div> */}
            
           </div>
         </section>
         </div>
       </div>
     </main>
   );
 }
 
 export default SignIn;